import { httpwmsapi } from 'src/services';

// Action Types
export const Types = {
  SCHEDULE_RECEIVING_LOADING: 'schedule_receiving/loading',
  SCHEDULE_RECEIVING_SET_DATA: 'schedule_receiving/set/schedule/data',
  SCHEDULE_RECEIVINGS_SET_DATA: 'schedule_receivings/set/schedule/data',
  SCHEDULE_RECEIVINGS_SET_PAGING: 'schedule_receiving/set/schedule/paging',
  SCHEDULE_RECEIVINGS_FILTERS_CHIP: 'schedule_receiving/set/filter_chip',
  SCHEDULE_RECEIVINGS_SET_FILTER: 'schedule_receiving/set/schedule/filter',
  SCHEDULE_RECEIVING_CONFIG_LOADING: 'schedule_receiving_config/config/loading',
  SCHEDULE_RECEIVING_CONFIG_SET_DATA: 'schedule_receiving_config/config/set/data',
};

// Reducer
const initialState = {
  loading: false,
  schedule_receiving: {},
  schedule_receivings: [],
  schedule_receivings_paging: { limit: 25, offset: 0, total: 0, page: 0 },
  schedule_receivings_filters_chip: [],
  schedule_receivings_filters: {
    initial_date: new Date(),
  },
  loading_config: false,
  schedule_receiving_config: {},
};

// Action Creators
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case Types.SCHEDULE_RECEIVING_LOADING:
      return { ...state, loading: action.payload };
    case Types.SCHEDULE_RECEIVING_SET_DATA:
      return { ...state, schedule_receiving: action.payload };
    case Types.SCHEDULE_RECEIVINGS_SET_DATA:
      return { ...state, schedule_receivings: action.payload };
    case Types.SCHEDULE_RECEIVINGS_SET_PAGING:
      return { ...state, schedule_receivings_paging: action.payload };
    case Types.SCHEDULE_RECEIVINGS_FILTERS_CHIP:
      return { ...state, schedule_receivings_filters_chip: action.payload };
    case Types.SCHEDULE_RECEIVINGS_SET_FILTER:
      return { ...state, schedule_receivings_filters: action.payload };
    case Types.SCHEDULE_RECEIVING_CONFIG_LOADING:
      return { ...state, loading_config: action.payload };
    case Types.SCHEDULE_RECEIVING_CONFIG_SET_DATA:
      return { ...state, schedule_receiving_config: action.payload };

    default:
      return state;
  }
}

export const Creators = {
  scheduleReceivingLoading: (value) => ({ type: Types.SCHEDULE_RECEIVING_LOADING, payload: value }),
  scheduleReceivingSetData: (scheduleReceiving) => ({
    type: Types.SCHEDULE_RECEIVING_SET_DATA,
    payload: scheduleReceiving,
  }),
  scheduleReceivingsSetData: (scheduleReceivings) => ({
    type: Types.SCHEDULE_RECEIVINGS_SET_DATA,
    payload: scheduleReceivings,
  }),
  scheduleReceivingsSetPaging: (scheduleReceivings_paging) => ({
    type: Types.SCHEDULE_RECEIVINGS_SET_PAGING,
    payload: scheduleReceivings_paging,
  }),
  scheduleReceivingsSetFiltersChip: (scheduleReceivings_filters_chip) => ({
    type: Types.SCHEDULE_RECEIVINGS_FILTERS_CHIP,
    payload: scheduleReceivings_filters_chip,
  }),
  scheduleReceivingsSetFilters: (scheduleReceivings_filters) => ({
    type: Types.SCHEDULE_RECEIVINGS_SET_FILTER,
    payload: scheduleReceivings_filters,
  }),
  scheduleReceivingConfigLoading: (value) => ({ type: Types.SCHEDULE_RECEIVING_CONFIG_LOADING, payload: value }),
  scheduleReceivingConfigSetData: (schedule_receiving_config) => ({
    type: Types.SCHEDULE_RECEIVING_CONFIG_SET_DATA,
    payload: schedule_receiving_config,
  }),

  setScheduleReceiving: (body) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .post(`/v1/agenda-recebimento/`, body, {
          headers: { 'Content-Type': 'application/json' },
          timeout: 1000 * 60,
        })
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  getScheduleReceivingByCodigo: (codigo) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/agenda-recebimento/${codigo}`, {
          timeout: 1000 * 60,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  putScheduleReceiving: (body) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .put(`/v1/agenda-recebimento/`, body, {
          headers: { 'Content-Type': 'application/json' },
          timeout: 1000 * 60,
        })
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  deleteScheduleReceiving: (codigo) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .delete(`/v1/agenda-recebimento/${codigo}`, {
          timeout: 1000 * 15,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  getScheduleReceiving: () => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/agenda-recebimento/`, {
          timeout: 1000 * 50,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  getScheduleReceivingConfig: () => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/config-horarios-agenda-receb/`, {
          timeout: 1000 * 50,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  postBlockedDate: (body) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .post(`/v1/config-horarios-agenda-receb/bloqueia-data-hora`, body, {
          timeout: 1000 * 60,
        })
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  setScheduleReceivingConfig: (body) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .post(`/v1/config-horarios-agenda-receb/`, body, {
          headers: { 'Content-Type': 'application/json' },
          timeout: 1000 * 60,
        })
        .then((data) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  deleteBlockedScheduleReceiving: (codigo) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .delete(`/v1/config-horarios-agenda-receb/${codigo}`, {
          timeout: 1000 * 15,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  getPublicScheduleReceiving: (customerId) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .get(`/v1/agenda-recebimento/public/agenda-recebimento`, {
          params: { customer_id: customerId },
          timeout: 1000 * 50,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },

  registerObservationReader: (id) => {
    return new Promise((resolve, reject) => {
      httpwmsapi
        .patch(`/v1/agenda-recebimento/set-observation-reader/${id}`, {
          timeout: 1000 * 15,
        })
        .then(({ data }) => resolve(data))
        .catch((error) => reject(error));
    });
  },
};
